import { l as _inherits, h as _createClass, i as _classCallCheck, m as _callSuper } from './_rollupPluginBabelHelpers-e71b1aad.js';
import PropTypes from 'prop-types';
import React__default from 'react';
import ReactDOM from 'react-dom';

var ReactPortal = /*#__PURE__*/function (_React$Component) {
  function ReactPortal(props) {
    var _this;
    _classCallCheck(this, ReactPortal);
    _this = _callSuper(this, ReactPortal, [props]);
    if (typeof window !== 'undefined') {
      _this.portalRoot = document.getElementById('react-portal');
      _this.portalContainer = document.createElement('div');
    }
    return _this;
  }
  _inherits(ReactPortal, _React$Component);
  return _createClass(ReactPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$portalRoot;
      (_this$portalRoot = this.portalRoot) === null || _this$portalRoot === void 0 ? void 0 : _this$portalRoot.appendChild(this.portalContainer);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$portalRoot2;
      (_this$portalRoot2 = this.portalRoot) === null || _this$portalRoot2 === void 0 ? void 0 : _this$portalRoot2.removeChild(this.portalContainer);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      if (typeof window !== 'undefined') {
        return ReactDOM.createPortal(children, this.portalContainer);
      }
      return null;
    }
  }]);
}(React__default.Component);
ReactPortal.propTypes = {
  children: PropTypes.node.isRequired
};

export { ReactPortal as R };
//# sourceMappingURL=ReactPortal-f1f8cb85.js.map
